import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CodeOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"code_off"}/>
}
